module.exports = __webpack_public_path__ + "static/media/29FUNOV13.9175380b.jpg";